import { DescriptionsList, MyTabs } from "@components/EnterpriseDetail"
import React, { useState } from "react"
import { attachmentColumnsFn, descList } from "./data"
import { Alert, Avatar, Col, Row, Table, Timeline } from "antd"
import { BackBan, Preview } from "@components/index"
import ProTable from "@ant-design/pro-table"
import { AuditStatusTag, AuditTimeLine } from "../../../SaleContract/cpnts/SaleContractDetail"
import { PurchaseContractOperate } from '../../data'
import AddPurchaseContractModalForm from "../AddPurchaseContract"
import { usePurchaseContractHooks } from "../../hooks"
import { OperateActionType } from "@components/Finance/Contract/data"
import { OperateActionType as AuditOperateActionType } from "@components/Finance/ContractAudit/data"
import { useCommonApiHooks } from "@hooks/index"
import { BASEURL } from "@api/index"
import { parseSearch } from "@utils/index"
import { useLocation } from "react-router-dom"
import { PurchaseContractAuditOperate } from "@components/Finance/ContractAudit/cpnts/PurchaseContractAudit/data"
import { ContractAuditModalForm } from "@components/Finance/ContractAudit/cpnts/SaleContractAudit"
import { useContractAuditHooks } from "@components/Finance/ContractAudit/cpnts/PurchaseContractAudit/hooks"

const ContractInfo = ({dataObj}: any) => {
    const [previewProps, setPreviewProps] = useState({visible: false, src: undefined})
    const operate = (type: string, record: any) => {
    const { url: src } = record || {}
    if (type === '预览') {
        setPreviewProps({
            visible: true,
            src
        })
    }
    }
    const columns = attachmentColumnsFn(operate)
    return (<div style={{padding: 20}}>
        <div style={{background: '#fff'}}><div className="zen-ban">基本信息</div></div>
        <DescriptionsList data={dataObj||{}} descList={descList} />
        <div style={{background: '#fff', marginBottom: 20}}><div className="zen-ban">附件信息</div></div>
        <Table columns={columns} dataSource={dataObj?.files||[]} pagination={false} rowKey="id" />
        <Preview {...previewProps} modalProps={{maskClosable: false, onCancel: () => setPreviewProps({...previewProps, visible: false})}}></Preview>
    </div>)
}


const aduitLine = [
    {
        name: '章三',
        time: '2023-03-06 16:22:20',
        desc: '已提交申请，待1级审批（李一一）',
        remark: 'xxxxccxjkhkf',
        status: 1, 
    },
    {
        name: '章三',
        time: '2023-03-06 16:22:20',
        desc: '已提交申请，待1级审批（李一一）',
        remark: 'xxxxccxjkhkf',
        status: 2, 
    },
    {
        name: '章三',
        time: '2023-03-06 16:22:20',
        desc: '已提交申请，待1级审批（李一一）',
        remark: 'xxxxccxjkhkf',
        status: 3, 
    },
    {
        name: '章三',
        time: '2023-03-06 16:22:20',
        desc: '已提交申请，待1级审批（李一一）',
        remark: 'xxxxccxjkhkf',
        status: 4, 
    },
    {
        name: '章三',
        time: '2023-03-06 16:22:20',
        desc: '已提交申请，待1级审批（李一一）',
        remark: 'xxxxccxjkhkf',
        status: 5, 
    },
]

type PurchaseContractDetailProps = {
    contractId: React.Key;
    fromPath?: string;
}
export const PurchaseContractDetail = ({contractId, fromPath}: PurchaseContractDetailProps) => {

    const [contractInfo, setContractInfo, getApi] = useCommonApiHooks({url: `${BASEURL}/contract/contractDetail`, method: 'POST'}, {contractId}, true) 
    const [aduitLine, setAduitLine, getAduitLineApi] = useCommonApiHooks({url: `${BASEURL}/auditLog/getAuditLog`, method: 'POST'}, {keyId: contractId, type: 1}, true) 

    const { 
        commonModalFormProps,
        setCommonModalFormProps,
        createOperate
    } = usePurchaseContractHooks()

    const {
        formRef: auditFormRef,
        commonModalFormProps: auditModalFormProps,
        setCommonModalFormProps: setAuditModalFormProps,
        createOperate: auditCreateOperate,
    } = useContractAuditHooks()

    const reFush = () => {
        getApi({contractId})
        getAduitLineApi({keyId: contractId, type: 1})
    }

    const operate = async (type: OperateActionType | AuditOperateActionType, record: any) => {
        const { id, reason, status } = record || {}
        const action = createOperate(record, reFush)
        const auditAction = auditCreateOperate(record, reFush)
        switch(type) {
            case '采购合同-审批通过':
            case '采购合同-审批拒绝':
            case '采购合同-作废合同':
                auditAction(type, {})
                break;
            default:
                action(type as any, {})
        }
    }
    return (<>
        <BackBan 
            title={<>{contractInfo?.sysNumber} <AuditStatusTag status={contractInfo.status} /></>}
            actions={
                // @ts-ignore
                fromPath === '/finance/contractAudit' ? <PurchaseContractAuditOperate type="primary" record={contractInfo||{}} operate={operate} /> as any : <PurchaseContractOperate type="primary" record={contractInfo||{}} operate={operate} /> as any
            }
        />
        <Row gutter={[24,12]} justify="space-between" style={{width: 'calc(100% + 12px)'}}>
            <Col span={17} >
                <div style={{background: '#fff'}}>
                    <ContractInfo dataObj={contractInfo} />
                </div>
            </Col>
            <Col span={7} style={{background: '#fff'}}>
                <div style={{background: '#fff', marginBottom: 20, marginTop: 20}}><div className="zen-ban">流程动态</div></div>
                <div style={{background: '#F5F7FE', borderRadius: 8, padding: 20}}>
                    <AuditTimeLine aduitLine={aduitLine} />
                </div>
            </Col>
        </Row>
        <AddPurchaseContractModalForm
            modalProps={{
                onCancel: () => setCommonModalFormProps({...commonModalFormProps, visible: false}),
                maskClosable: false
            }}  
            {...commonModalFormProps} 
        />
        <ContractAuditModalForm
            modalProps={{
                onCancel: () => setAuditModalFormProps({...auditModalFormProps, visible: false}),
                maskClosable: false
            }}  
            formRef={auditFormRef}
            {...auditModalFormProps} 
        />
    </>
    )
}


export default () => {
    const { search } = useLocation();
    const { contractId, fromPath } = parseSearch(search)
    return <PurchaseContractDetail contractId={contractId} fromPath={fromPath} />
}